import { getTaskType } from '../../Task.api'

export function getTaskEditTypeModalItems(search, params) {
  return getTaskType({
    ...(search ? { name: search } : null),
    ...params,
  })
}
